import { APP_BASE_HREF } from '@angular/common';
import { ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { LoggerErrorHandler, loggerErrorHandlerOptions } from './shared/services/error-handling/error-handler.service';
import { ErrorHandlerApiService } from './shared/services/error-handling-api/error-handler-api.service';
import { Http } from '@angular/http';
import { ConfigurationService } from './shared/services/configuration/configuration.service';
import { AuthService } from './shared/services/auth.service';
import { HttpClient } from './shared/services/http.service';
import { PLApplicationProgressService } from './pages/personal-loans/shared/services/application-progress.service';
import { ApiFactories } from './shared/services/api.providers';
import { MixpanelService } from './shared/services/mixpanel.service';
import { ConfigurationService as ConfigService } from './shared/services/configuration/configuration.service';
import { DashboardDataCache } from './shared/services/dashboard/dashboard-data.cache';
import { IOvationService } from './pages/personal-loans/shared/services/iovation/iovation.service';
import { QueryParamService } from './shared/services/session/shared/session/query-param-service/query-param.service';
import { ZoneAwareErrorDetectionService } from './shared/services';

const apiConfig = (http: Http) => () => {};

export const providers = [
  { provide: APP_BASE_HREF, useValue: '/' },
  { provide: ErrorHandler, useClass: LoggerErrorHandler},
  { provide: 'LoggerErrorHandlerOptions', useValue: loggerErrorHandlerOptions },
  HttpClient,
  {
    provide: APP_INITIALIZER,
    useFactory: apiConfig,
    deps: [ Http ],
    multi: true
  },
  ...ApiFactories,
  PLApplicationProgressService,
  AuthService,
  MixpanelService,
  ConfigService,
  ConfigurationService,
  DashboardDataCache,
  IOvationService,
  ErrorHandlerApiService,
  QueryParamService,
  ZoneAwareErrorDetectionService
];
